module.exports = __webpack_public_path__ + "media/a-1.2415719f.mp3";